// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"1e43ca73","146":"5a6af956","190":"7bf247f2","286":"db78ab68","373":"01767ac2","453":"d7d70089","639":"98f31ca7"}[chunkId] + ".chunk.js";
};